import { useState, useEffect } from 'react';
import './index.css';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Tooltip from '@mui/material/Tooltip';
import { changePassword, fetchUserDetails } from '../../store/app/apis';
import Toast from 'light-toast';
import { connect } from 'react-redux';
import { setUserDetail } from '../../store/app';
import { getCleanTime } from '../../utils';
export function SettingRoute({ fetchUserDetails, changePassword, userDetail, ...props }) {
  const [, setUser] = useState('');
  const [data, setData] = useState({
    id: '',
    name: '',
    username: '',
    mt: '',
  });
  const [pass, setPass] = useState({
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [setPasswordErr] = useState('');
  const dialogOpenHandler = () => {
    setDialogOpen(true);
  };

  const cancelDialog = () => {
    setDialogOpen(null);
  };

  const handleOldPasswordChange = (e) => {
    setPass((prev) => ({
      ...prev,
      oldpassword: e.target.value,
    }));
  };

  const handleNewPasswordChange = (e) => {
    setPass((prev) => ({
      ...prev,
      newpassword: e.target.value,
    }));
  };

  const handleConfirmPasswordChange = (e) => {
    setPass((prev) => ({
      ...prev,
      confirmpassword: e.target.value,
    }));
  };

  const onChangePassword = (event) => {
    event.preventDefault();
    if (pass?.newpassword !== pass?.confirmpassword) {
      Toast.fail('password does not match');
      setPasswordErr('password does not match');
    }
    changePassword({
      oldpassword: pass?.oldpassword,
      newpassword: pass?.newpassword,
    }).then((res) => {
      setDialogOpen(null);
      setUser(res);
    });
  };
  useEffect(() => {
    fetchUserDetails(props.id).then((res) => {
      setData(res);
      setUserDetail(res);
    });
  }, []);

  useEffect(() => {
    setData((prev) => {
      return {
        ...prev,
        ...userDetail,
      };
    });
  }, [userDetail]);

  return (
    <div className="accounttop">
      <div className="accountInfo">
        <div className="accountHeading">
          <h4>ACCOUNT INFORMATION</h4>
        </div>
        <div className="infoItem">
          <p>Username:</p>
          <span className="infospan">{data?.username}</span>
        </div>
        <div className="infoItem">
          <p>Name:</p>
          <span className="infospan">{data?.name}</span>
        </div>
      </div>
      <div className="changePassword">
        <div className="accountHeading">
          <h4>CHANGE PASSWORD</h4>
        </div>
        <div>
          <div className="passwordInfo">
            <p>Password last changed: </p>
            <p>{getCleanTime(data?.mt)} </p>
          </div>
          <p className="passwordpara">For best security practices you should update your password every 6 months.</p>
        </div>
        <div className="passwordbuttons">
          <button>Update</button>
          <button className="resetbutton" onClick={dialogOpenHandler}>
            Reset Password
          </button>
        </div>
      </div>
      {dialogOpen && (
        <Dialog open={dialogOpen}>
          <div className="dialogDiv">
            <div className="dialogTop">
              <CloseIcon onClick={cancelDialog} sx={{ float: 'right', paddingBottom: 0, cursor: 'pointer' }} />
              <h1>Change Password</h1>
            </div>
            <div>
              <form id="Change-Password" onSubmit={onChangePassword}>
                <div className="inputdiv">
                  <label>Old Password </label>
                  <input
                    type="text"
                    placeholder="Enter Old Password"
                    name="oldpassword"
                    required={true}
                    autoComplete="off"
                    onChange={handleOldPasswordChange}
                    value={pass?.oldpassword}
                  />
                  <Tooltip title="Old password should not be same as New password" placement="right" arrow>
                    <InfoOutlinedIcon className="icon" />
                  </Tooltip>
                </div>
                <div className="inputdiv">
                  <label> New Password </label>
                  <input
                    type="password"
                    placeholder="Enter New Password"
                    name="newpassword"
                    required={true}
                    onChange={handleNewPasswordChange}
                    value={pass?.newpassword}
                    autoComplete="off"
                  />
                  <Tooltip title="Please keep password of minimum 8 characters" placement="right" arrow>
                    <InfoOutlinedIcon className="icon" />
                  </Tooltip>
                </div>
                <div className="inputdiv">
                  <label>Confirm Password </label>
                  <input
                    type="password"
                    placeholder="Confirm New Password"
                    name="confirmpassword"
                    required={true}
                    onChange={handleConfirmPasswordChange}
                    value={pass.confirmpassword}
                    autoComplete="off"
                  />
                </div>
                <div className="buttondiv">
                  <button className="buttonpasswordchange" type="submit" onClick={onChangePassword}>
                    Change Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  userDetail: state.app.userDetail,
});
const mapDispatchToProps = { setUserDetail, fetchUserDetails, changePassword };

export default connect(mapStateToProps, mapDispatchToProps)(SettingRoute);
